import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

//Servicios
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { LogoutService } from '@/app/services/security/logout.service';


//Librerías exernas
import Swal from 'sweetalert2';
import { take } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavbarComponent {

  private authService = inject(AuthService);
  private logoutService = inject(LogoutService);
  private router = inject(Router);
  tokenReader = inject(TokenReaderService);

  isReportsRole = this.tokenReader.isReportUser;

  currentName = this.tokenReader.usuario()?.nombre;

  constructor() {}

  logout(){
    Swal.fire({
      title: '¿Seguro que deseas salir?',
      // text: "No se ha registrado el usuario. ¿Seguro que deseas salir?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#999999',
      cancelButtonColor:  '#1c869e',
      confirmButtonText: 'Salir',
      cancelButtonText: 'No salir',
      allowOutsideClick: false,
      reverseButtons: false
    }).then((result) => {
      if(result.value){
        this.authService.isAuthenticated$.pipe(take(1)).subscribe((isAuth) => {
          if (isAuth) {
            // Cierra la sesión local, la de Auth0 y la del IdP federado (GateOne).
            this.logoutService.cerrarSesion();
          } else {
            this.router.navigate(['/login']);
          }
        });

      }
    });

  }

}
